/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let product_title = document.querySelectorAll(".product-title");
let el = document.querySelectorAll(".product-description");
for(let i=0;i<product_title.length;i++) {
	product_title[i].addEventListener("click", () => {
    	if(el[i].classList.length === 1) {
      		el[i].classList.add("show");
      		document.querySelectorAll(".plusminus")[i].innerHTML = `
				<svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
                  <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                </svg>
			`;
        } else {
          	el[i].classList.remove("show");
          	document.querySelectorAll(".plusminus")[i].innerHTML = "";
          	document.querySelectorAll(".plusminus")[i].innerHTML = `
				<svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
                  <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                    <path d="M8,1 L8,15"></path>
                    <path d="M1,8 L15,8"></path>
                  </g>
                </svg>
			`;
        }
    })
}




$( ".ProductListWrapper" ).on( "click", ".ad_to_cart_coll", function() {
  
    
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1);    // paste your id product number
  //$('data-drawer-id="sidebar-cart"').trigger( "click" );
    
    // alert("Hello");
  	$(".PageOverlay").addClass('is-visible');
    $("#sidebar-cart").attr( 'aria-hidden', 'false' );
    

   $('.Drawer__Close').click(function(){   
  	
     $(".PageOverlay").removeClass('is-visible');
    $("#sidebar-cart").attr( 'aria-hidden', 'true' );
   });
  
});



function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }   
    
  }); 
 
}






$( document ).ready(function() {
    
  
$('.logo-wrp').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  wrapAround: true,
  prevNextButtons: false,
  autoPlay: 2000,
  pageDots: false,
  	selectedAttraction: 0.005,
	friction: 0.50
  
});
  
  
$('.post-slider .ArticleList').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  wrapAround: false,
  prevNextButtons: true,
  pageDots: false,
  	selectedAttraction: 0.01,
	friction: 0.20
  
});

  
  
  
});